









































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import ProviderConnectionsFilter from "@/components/Settings/ProviderConnections/ProviderConnectionsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {ProviderConnectionItem} from "@/store/settings/provider_connections/types";
import { customSort } from '@/utils/data-helper';

@Component({components: {ProviderConnectionsFilter, ScrollButton}})
export default class ProviderConnections extends Vue {
  @Getter("providerConnections") providerConnections: any;
  private is_show_filter = false;
  private currentSort= "name";
  private currentSortOrder= "desc";

  private tableFields = [
    'name',
    'server_name',
    'status',
    'status_duration',
    'messages_in_queue',
    'delivered_messages',
    'mt_per_min',
    'mo_per_min'
  ];

  get tableFieldsActive(){
    if (localStorage.getItem('providerConnectionsTableFields')){
      let saveData = JSON.parse(localStorage.getItem('providerConnectionsTableFields') || '');
      if (saveData) {
        this.tableFields = saveData;
        return saveData
      }
    }
    return this.tableFields;
  };

  @Watch('tableFields')
  getValue(val:string){
    localStorage.setItem('providerConnectionsTableFields',JSON.stringify(val))
  }

  get tableData(): ProviderConnectionItem[] {
    return this.providerConnections ?? [];
  }

  get queriedData():ProviderConnectionItem[] {
    return customSort<ProviderConnectionItem>(this.currentSort, this.currentSortOrder, this.tableData);
  }

  customSort(value:any):any {
    return customSort<ProviderConnectionItem>(this.currentSort, this.currentSortOrder, value);
  }

}
